//window.onload=function() { Load() }
function Load() {
  let header_height = $('#shopify-section-header').height();
  $('body').css('padding-top', header_height);
}
$(document).ready(function () {
  function dis_price() {
    $('span[data-product-id="7100497363081"]').html('$30.00 <s style="font-weight:400;">$50.00</s>');
    $('span[data-product-id="7100498968713"]').html('$50.00 <s style="font-weight:400;">$75.00</s>');
    $('span[data-product-id="7100499001481"]').html('$100.00 <s style="font-weight:400;">$150.00</s>');
  }
  dis_price();
});
// $(window).resize(function () {
//   Load();
// });

function getCart(item_id) {
  var product_ids = [];
  $.getJSON("/cart.js")
    .done(function (res) {
      $.each(res.items, function (i, item) {
        product_ids.push(item.id);
      })

      if (product_ids.includes(item_id)) {
        $('button.add_to_cart.variant-41003359338633, button.add_to_cart.variant-41003342692489, button.add_to_cart.variant-41003361566857').attr("type", "button").addClass("disabled").html("Only one gift card per purchase");
      }
      console.log(product_ids);
    }
  );
}

$(document).ajaxComplete(function (event, xhr, settings) {
  var id = xhr.responseJSON.id;
  if (id == 41003359338633 || id == 41003342692489 || id == 41003361566857) {
    if (settings.url === "/cart/add.js") {
      getCart(id);
    }
  }
});




$('.toggle-all--true > div:first-child .toggle_list').css("display", "block");
$('.toggle-all--true > div:first-child .toggle').attr("aria-expanded", "true");

  $(document).ready(function() {
    if (window.location.href.indexOf("/cart") > -1) {
      console.log('faster-redirect');
      window.location.href = '/?viewcart=true';
    }
  });

// Rebuy product add-on ("You may also like"): make the thumbnail and title
// open the product page instead of only ticking the checkbox.
document.addEventListener('click', function (e) {
  var target = e.target;
  if (!target.closest) return;
  var item = target.closest('.rebuy-addon__item');
  if (!item) return;
  // Leave the checkbox and any existing link (e.g. "Learn More") alone
  if (target.closest('.rebuy-addon__item-checkbox, a, button, input')) return;
  if (!target.closest('.rebuy-addon__item-image, .rebuy-addon__item-info')) return;
  var link = item.querySelector('a[href*="/products/"]');
  if (!link) return;
  e.preventDefault();
  e.stopPropagation();
  window.location.href = link.href;
}, true);

document.addEventListener('mouseover', function (e) {
  var el = e.target.closest && e.target.closest('.rebuy-addon__item-image, .rebuy-addon__item-info');
  if (el && !el.style.cursor) el.style.cursor = 'pointer';
});
